import {IssueSubscriptionStatus} from '@github-ui/server-persisted-queries'
import type {IssueSubscriptionStatusQuery} from '@github-ui/server-persisted-queries/types/IssueSubscriptionStatus'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type SubscriptionStatus = NonNullable<NonNullable<IssueSubscriptionStatusQuery['repository']>['issue']>

export function subscriptionStatusQueryKey(owner: string, repo: string, number: number) {
  return ['issue-viewer', 'subscription-status', {owner, repo, number}] as const
}

export async function fetchSubscriptionStatus(
  owner: string,
  repo: string,
  number: number,
  signal?: AbortSignal,
): Promise<SubscriptionStatus> {
  const response = await verifiedFetchJSON(
    `/${owner}/${repo}/issues/${number}/subscription_status?queryId=${IssueSubscriptionStatus}`,
    {signal},
  )
  if (!response.ok) {
    throw new Error(`Subscription status fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {data?: IssueSubscriptionStatusQuery; errors?: unknown[]}
  const issue = json.data?.repository?.issue
  if (!issue) {
    throw new Error('Subscription status query returned no data')
  }

  return issue
}
